import { TextRegular } from 'UiKit/typography';
import getStatusColor from 'Helper/getStatusColor';

import styles from './styles.module.css';

export const tableList = ({ t = (key) => key }) => {
  return [
    {
      name: t('tableColumn.date'),
      width: 130,
      key: 'date',
      sortKey: 'date',
      component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
    },
    {
      name: t('tableColumn.host'),
      width: 130,
      key: 'host',
      sortKey: 'host',
      component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
    },
    {
      name: t('tableColumn.assistingOperator'),
      width: 190,
      key: 'operatorPembantu',
      sortKey: 'operatorPembantu',
      component: ({ value }) => <TextRegular className={`${styles['column__text']} ${styles['column__text--truncate']}`}>{value}</TextRegular>,
    },
    {
      name: t('tableColumn.room'),
      width: 200,
      key: 'ruangan',
      component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
    },
    {
      name: t('tableColumn.requestTime'),
      width: 130,
      key: 'jamRequest',
      component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
    },
    {
      name: t('tableColumn.helpStartTime'),
      width: 150,
      key: 'jamMulaiBantu',
      component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
    },
    {
      name: t('tableColumn.helpEndTime'),
      width: 150,
      key: 'jamSelesaiBantu',
      component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
    },
    {
      name: t('tableColumn.helpDuration'),
      width: 150,
      key: 'durasiBantu',
      sortKey: 'durasiBantu',
      component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
    },
    {
      name: t('tableColumn.status'),
      width: 200,
      key: 'status',
      component: ({ value, values }) => {
        const isViolation = values?.isViolation;
        const status = value;

        const color = getStatusColor(isViolation);

        return (
          <TextRegular color={color} className={`${styles['column__text']} ${styles['column__text--truncate']}`}>
            {status}
          </TextRegular>
        );
      },
    },
    {
      name: t('tableColumn.notes'),
      width: 230,
      key: 'notes',
      component: ({ value }) => <TextRegular className={`${styles['column__text']} ${styles['column__text--truncate']}`}>{value}</TextRegular>,
    },
  ];
};
